module.exports = __webpack_public_path__ + "img/Account.031305fc.svg";